import React, { useState, useRef, useEffect } from "react";
import "./ChatTab.css";

const RAILWAY = process.env.REACT_APP_API_BASE || "";

export default function ChatTab() {
  const [messages, setMessages] = useState([]); // { role: "user"|"assistant", content }
  const [input, setInput]       = useState("");
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState(null);
  const endRef = useRef(null);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages, loading]);

  const send = async () => {
    const text = input.trim();
    if (!text || loading) return;
    const next = [...messages, { role: "user", content: text }];
    setMessages(next);
    setInput("");
    setLoading(true);
    setError(null);
    try {
      const r = await fetch(`${RAILWAY}/api/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ messages: next }),
      });
      const d = await r.json();
      if (!r.ok || d.error) throw new Error(d.error || `Error ${r.status}`);
      setMessages(m => [...m, { role: "assistant", content: d.reply }]);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const onKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); }
  };

  return (
    <div className="chat">
      <div className="chat-messages">
        {messages.length === 0 && (
          <div className="chat-empty">
            <div className="chat-empty-icon">💬</div>
            <p className="chat-empty-title">Ask me anything</p>
            <p className="chat-empty-sub">
              A general assistant built into the tool. I don't have live access to your Teambridge
              data, but I can help with questions, explanations, drafting, and how-to.
            </p>
          </div>
        )}
        {messages.map((m, i) => (
          <div key={i} className={`chat-msg ${m.role}`}>
            <div className="chat-bubble">{m.content}</div>
          </div>
        ))}
        {loading && (
          <div className="chat-msg assistant">
            <div className="chat-bubble chat-typing"><span /><span /><span /></div>
          </div>
        )}
        {error && <div className="chat-error">⚠ {error}</div>}
        <div ref={endRef} />
      </div>

      <div className="chat-input-row">
        <textarea
          className="chat-input"
          placeholder="Type a message…  (Enter to send, Shift+Enter for a new line)"
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={onKey}
          rows={1}
        />
        <button className="chat-send" onClick={send} disabled={loading || !input.trim()}>
          {loading ? <span className="spinner" /> : "Send"}
        </button>
      </div>
    </div>
  );
}
